import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForNotFor } from './components/ForNotFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel } from './utils/metaPixel';
import { setSEO } from './utils/seo';
export function App() {
  useEffect(() => {
    initMetaPixel();
    setSEO({
      title: 'Después del Engaño: 7 pasos para decidir si irte o quedarte',
      description: 'La hoja de ruta de 7 pasos para recuperar tu paz mental tras una infidelidad y decidir tu futuro sin culpa ni arrepentimientos.',
      image: 'https://cdn.magicpatterns.com/uploads/2DvvmRqAmHWDHwPjkhWpYu/IMG_8530.png'
    });
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-offwhite selection:bg-brand-amber/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItDidntWork data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <ForNotFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferBlock data-id="element-12" />
      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}